class MasonryGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log("Masonry Grid by PurplePanda Ecom");
    this.addEventListener("click", this.handleClicked.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleClicked.bind(this));
  }

  handleClicked(event) {
    if (event.target.closest("[data-slide-index]")) {
      let slideNumber = parseInt(
        event.target
          .closest("[data-slide-index]")
          .getAttribute("data-slide-index")
      );
      const customEvent = new CustomEvent("PPModal:open", {
        detail: {
          slide: slideNumber,
        },
      });
      this.closest("section").dispatchEvent(customEvent);
    }
  }
}
customElements.define("masonry-grid", MasonryGrid);

class PurplePandaModal extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll(
      ".modal-content .modal-slide[data-slide-index]"
    );
    this.slideContent = this.querySelector(".modal-popup-image-container");
    this.content = this.querySelector(".modal-popup-container");
  }

  connectedCallback() {
    console.log("Modal Scroll Carousel by PurplePanda Ecom");
    this.selectSlide();
    this.addListeners();
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.handleKeys.bind(this));
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  addListeners() {
    document.addEventListener("keydown", this.handleKeys.bind(this));
    this.addEventListener("click", this.handleClick.bind(this));
    this.closest("section").addEventListener(
      "PPModal:open",
      this.handleEvent.bind(this)
    );
  }

  handleEvent(event) {
    let nextSlide = event.detail.slide;
    this.selectSlide(nextSlide);
    this.open();
  }

  handleClick(event) {
    if (event.target.closest("[data-close]")) {
      this.close();
      return;
    }

    if (event.target.closest("[data-prev]")) {
      this.prevItem();
      return;
    }

    if (event.target.closest("[data-next]")) {
      this.nextItem();
      return;
    }

    if (event.target.closest("[data-slide-index]")) {
      let slideNumber = parseInt(
        event.target
          .closest("[data-slide-index]")
          .getAttribute("data-slide-index")
      );
      this.selectSlide(slideNumber);
      return;
    }
  }

  handleKeys({ key }) {
    if (!this.open) {
      return;
    }

    if (key === "Escape") {
      this.close();
    }
    if (key === "ArrowRight") {
      this.nextItem();
    }

    if (key === "ArrowLeft") {
      this.prevItem();
    }
  }

  nextItem() {
    this.selectSlide((this.currentSlide + 1) % this.slides.length);
  }

  prevItem() {
    let nextIndex =
      (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.selectSlide(nextIndex);
  }

  selectSlide(index = 0) {
    this.currentSlide = index;
    let image;
    let videoObj;
    if (this.slides[index].querySelector(".modal-image-container video")) {
      image = this.slides[index]
        .querySelector(".modal-image-container video")
        .cloneNode(true);
    } else {
      image = this.slides[index]
        .querySelector(".modal-image-container img")
        .cloneNode(true);
    }

    this.slideContent.innerHTML = "";
    this.slideContent.appendChild(image);

    let content = this.slides[index].querySelector(".modal-info-container");
    this.content.innerHTML = content.innerHTML;
    this.selectAdjacentItems();
  }

  selectAdjacentItems() {
    const adjacentIndices = [];
    const numSlides = this.slides.length;

    // Calculate the indices of the three previous and three next items
    for (let i = -3; i <= 3; i++) {
      if (i !== 0) {
        // Skip adding the current index
        let index = (this.currentSlide + i) % numSlides;
        // Ensure the index is positive
        if (index < 0) {
          index += numSlides;
        }
        adjacentIndices.push(index);
      }
    }

    // Rearrange the indices to ensure correct ordering
    adjacentIndices.sort((a, b) => a - b);

    //Remove Duplicates
    let removedDuplicates = [...new Set(adjacentIndices)];
    let mobileGridContainer = this.querySelector(
      ".modal-container [data-inspiration] .mansory-grid-mini"
    );
    adjacentIndices.forEach((index) => {
      let imageContainer = this.slides[index]
        .querySelector(".modal-image-container")
        .cloneNode(true);
      mobileGridContainer.appendChild(imageContainer);
    });

    // Select the slides corresponding to the adjacent indices
  }

  open() {
    this.isOpen = true;
    this.classList.add("open");
    setTimeout(() => {
      this.setAttribute("open", true);
    }, "200");
  }

  close() {
    this.isOpen = false;
    this.classList.remove("open");
    setTimeout(() => {
      this.removeAttribute("open");
    }, "200");
  }
}
customElements.define("x-modal-pp", PurplePandaModal);

class KlaviyoButton extends HTMLButtonElement {
  constructor() {
    super();
    this.masterForm = document.querySelector(
      `#${this.getAttribute("data-form")}`
    );
  }

  connectedCallback() {
    this.masterForm.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.addEventListener("click", this.handleClick.bind(this));
  }

  disconnectedCallback() {
    this.masterForm.removeEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.removeEventListener("click", this.handleClick.bind(this));
  }

  handleVariantChange(e) {
    if (e.detail.variant) {
      e.detail.variant.available
        ? this.setAttribute("hidden", true)
        : this.removeAttribute("hidden");
    }
  }

  handleClick(e) {
    e.preventDefault();
    let formId = this.getAttribute("data-klaviyo");
    if (formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push("openForm", formId);
    }
  }
}

customElements.define("klaviyo-button", KlaviyoButton, { extends: "button" });


 //PP-Gallery: Gallery onVariantChange Logic
document.documentElement.addEventListener("gallery:custom:change", (e) => {
  console.log(e);

  let variant = e.detail.variant;
  if (!variant) {
    return;
  }

  let productGalleryItems = document.querySelectorAll(
    "product-gallery [data-variants]"
  );
  let buttonItems = document.querySelectorAll(
    "product-gallery carousel-navigation button"
  );

  let thumbnails = document.querySelectorAll(
    "product-gallery-navigation button"
  );

  let currentSelectedImage = document.querySelector(
    '.product-gallery__thumbnail[aria-current="true"]'
  );


  productGalleryItems.forEach((item, index) => {

    let item_variants = JSON.parse(item.getAttribute("data-variants"));
    //console.log(item_variants, item_variants.includes(variant.id.toString()));
    if (!item_variants) {
      item.removeAttribute("hidden");
      buttonItems[index]?.removeAttribute("hidden");
      thumbnails[index]?.removeAttribute("hidden");
      //console.log("removed", item);
    } else {
      if (item_variants && item_variants.includes(variant.id.toString())) {
        item.removeAttribute("hidden");
        buttonItems[index]?.removeAttribute("hidden");
        thumbnails[index]?.removeAttribute("hidden");
      } else {
        item.setAttribute("hidden", true);
        buttonItems[index]?.setAttribute("hidden", true);
        thumbnails[index]?.setAttribute("hidden", true);
      }
    }

    let item_options = JSON.parse(item.getAttribute('data-options'));




    if(item_options && item_options.length){
      let hide = true;
      let downcased_options = [...variant.options].map((option) => {
        return option.toLowerCase();
      })

      item_options.forEach((option) => {
        if(downcased_options.includes(option)){
         hide = false;
        }
      })

      if(hide){
        item.setAttribute("hidden", true);
        buttonItems[index]?.setAttribute("hidden", true);
        thumbnails[index]?.setAttribute("hidden", true);
      }else{
        item.removeAttribute("hidden");
        buttonItems[index]?.removeAttribute("hidden");
        thumbnails[index]?.removeAttribute("hidden");
      }

    }

  });

  let firstButton = document.querySelector(
    "product-gallery carousel-navigation button:not([hidden])"
  );

  let remoteSlide = e.detail?.remoteSlide;
  let remoteSlideIndex = e.detail?.remoteSlideIndex;
  let gallery = document.querySelector("product-gallery scroll-carousel");

    gallery.select(remoteSlideIndex, {instant: true})
    let galleryNav = document.querySelector("product-gallery-navigation");
    console.log(galleryNav)
    if(galleryNav){
        let thumbs = galleryNav.querySelectorAll(`button:not([hidden])`);
        if(thumbs[remoteSlideIndex]){
          thumbs.remoteSlideIndex.click();
        }
    }

  // if(remoteSlide && !remoteSlide.hasAttribute("hidden") && gallery){

  //   let findIndex = gallery.cells.findIndex((cell) => cell === remoteSlide);
  //   gallery.select(findIndex, {instant: true})


  // }else{
  //   firstButton?.click();
  // }

});
